export default "__VITE_ASSET__1cea0693__"